module.exports = __webpack_public_path__ + "img/cdkf2.af48342e.jpg";